// extracted by mini-css-extract-plugin
module.exports = {"DoubleInputContainer":"CreateUser_DoubleInputContainer__16nSz","InputContainer":"CreateUser_InputContainer__1t7sV"};